import React from "react";

const Vision = () => {
  return (
    <div className="flex flex-col gap-4 justify-center items-center w-full md:py-[60px] pb-10 md:pb-[60px]">
      <div className="flex flex-col gap-4 justify-center w-full max-w-screen-xl px-5 xl:px-0">
        <div className="flex gap-5 items-center flex-col-reverse md:flex-row ">
          <div className="w-full md:w-3/4 flex flex-col gap-5">
            <p className="text-7xl">Our Vision</p>
            <p className="text-xl text-justify max-w-[95%]">
              To be Melbourne’s premier cleaning service, known for unwavering
              reliability, earned respect, and a steadfast commitment to
              unparalleled quality, compassionate care, and sustainable
              practices.
            </p>
          </div>
          <div className="w-1/4 pt-10">
            <img
              src="/assets/images/about/vision.png"
              alt=""
              className="w-[250px] h-auto"
            />
          </div>
        </div>

        <div className="flex gap-5 items-center md:flex-row-reverse flex-col">
          <div className="w-full md:w-3/4 flex flex-col items-end gap-5">
            <p className="text-7xl">Our Mission</p>
            <p className="text-xl text-justify">
              We aim to revolutionize the cleaning industry with our dedication
              to exceptional, eco-friendly cleaning services that enhance
              customer satisfaction and promote a healthier, greener Melbourne,
              ensuring every space we touch radiates cleanliness and well-being.
            </p>
          </div>
          <div className="w-1/4 pt-10">
            <img
              src="/assets/images/about/mission.png"
              alt=""
              className="w-[200px] h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vision;
